<p-fieldset [style]="{'border':'none'}" >
    <span *ngIf="skipSavingW4Info"
          style="color: red;">Please provide required information.</span>
    <p-table #dt [value]="taxInfo" [columns]="fedralInfotableColumns" [rows]="10" [responsive]="true">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" [ngSwitch]="col.field" style="overflow:ellipsis;word-break:break-all;">
                    <span class="p-column-title">{{col.header}}</span>
                  <span class="p-cell">
                    <div *ngSwitchCase="'status'">
                        <div text-align="center" *ngIf="row.taxInformation == 'Federal Income Tax'">
                            <button class="icon-button icon-action2" type="button" *ngIf="row[col.field] && (uiName == 'netPay' || newFederalFileName)">
                                <i class="fa fa-check-circle"></i>
                            </button>

                            <button class="icon-button icon-inaction" type="button" *ngIf="!row[col.field] || (!newFederalFileName && uiName != 'netPay') ">
                                <i class="fa fa-times-circle"></i>
                            </button>
                        </div>

                        <div text-align="center" *ngIf="row.taxInformation == 'State Income Tax'">
                            <button class="icon-button icon-action2" type="button" *ngIf="row[col.field] && (uiName == 'netPay' || newStateFileName)">
                                <i class="fa fa-check-circle"></i>
                            </button>

                            <button class="icon-button icon-inaction" type="button" *ngIf="!row[col.field] || (!newStateFileName && uiName != 'netPay') ">
                                <i class="fa fa-times-circle"></i>
                            </button>
                        </div>


                        <div text-align="center" *ngIf="row.taxInformation == 'Local Tax'">
                            <button class="icon-button icon-action2" type="button" *ngIf="row[col.field]">
                                <i class="fa fa-check-circle"></i>
                            </button>

                            <button class="icon-button icon-inaction" type="button" *ngIf="!row[col.field]">
                                <i class="fa fa-times-circle"></i>
                            </button>
                        </div>


                    </div>

                    <div *ngSwitchCase="'file'">
                        <span *ngIf="row.taxInformation == 'Federal Income Tax'">{{newFederalFileName}}</span>
                        <span *ngIf="row.taxInformation == 'State Income Tax'">{{newStateFileName}}</span>

                    </div>
                    <div *ngSwitchCase="'actions'">
                        <div text-align="center">

                            <button pButton *ngIf="row.taxInformation == 'Federal Income Tax' && (uiName == 'profile' || uiName == 'payee') && federalW4Id" class="action-icon" type="button" (click)="onClickDownload(federalW4Id)"
                                    icon="fa fa-download" pTooltip="Download Document"></button>

                            <button pButton class="action-icon" *ngIf="row.taxInformation == 'State Income Tax' && (uiName == 'profile' || uiName == 'payee') && stateW4Id" type="button" (click)="onClickDownload(stateW4Id)"
                                    icon="fa fa-download" pTooltip="Download Document"></button>



                            <button class="icon-button icon-action" (click)="editTaxInformation(row)" type="button">
                                <i class="fa fa-pencil"></i>
                            </button>
                        </div>
                    </div>

                    <div *ngSwitchDefault>{{row[col.field]}}</div>
                  </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-fieldset>

<!-- Dialog for deductions -->
<p-dialog header="State Income Tax" [(visible)]="stateTaxDialog" *ngIf="stateTaxDialog" [responsive]="true" showEffect="fade" [modal]="true"
          [style]="DialogStyle40">
    <form #stateIncomeTaxForm="ngForm">
        <div>
            <div class="p-grid" *ngFor="let question of stateQuestionList">
                <div class="p-col-12 p-md-4 p-lg-4">
                    <label for="{{question.key}}">{{question.description}} <span *ngIf="!question.isOptional">*</span></label>
                </div>

                <div [ngSwitch]="question.regexType">

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'SingleValue'">
                        <input type="text" pInputText placeholder="{{question.description}}" name="{{question.description}}" [(ngModel)]="stateFormData[question.parameterName]" [required]="!question.isOptional">
                    </div>

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'PickList'">

                        <p-dropdown [options]="question.options" placeholder="Select..." class="form-control" name="{{question.description}}" [(ngModel)]="stateFormData[question.parameterName]"
                                    [required]="!question.isOptional"></p-dropdown>

                    </div>
                </div>
            </div>
        </div>
        <!-- File Upload -->
        <div class="p-grid" *ngIf="uiName == 'profile' || uiName == 'payee'">
            <div class="p-col-12 p-md-4 p-lg-4">
                <label>File*&nbsp;
                    <!-- <button  *ngIf="stateFormData?.docFile?.id" pButton class="action-icon" type="button" (click)="onClickDownload(stateFormData)" icon="fa fa-download" pTooltip="Download Document"></button> -->
                </label>

            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
                <span *ngIf="newStateFileName">{{newStateFileName}}</span>
                <span *ngIf="newStateFileError">Federal and State file name cannot be same</span>

                <span style="cursor:pointer;padding-left:10px;">
          <app-file-load *ngIf="stateFormData&&stateTaxDialog" [docType]="DocumentType.W4Form" (loadHandler)="handleLoadedStateFile($event)" [chooseLabel]="fileUploadLabel">
          </app-file-load>
        </span>
            </div>
        </div>
        <!-- End File Upload -->
    </form>
    <p-footer>
        <div class="p-col-12" style="text-align:right;">
            <button type="button" class="button-inaction" pButton icon="fa fa-close" (click)="stateTaxDialog = false" label="Cancel"></button>
            <button type="button" class="button-action" pButton icon="fa fa-check" label="Add"
                    (click)="addStateTax()" [disabled]="!stateIncomeTaxForm.form.valid || ((newStateFileError || !newStateFileName) && (uiName == 'profile' || uiName == 'payee'))">
            </button>
            <!--   <button type="button" pButton icon="fa fa-check" (click)="updateTax()" label="Update" *ngIf="!newTax" [disabled]="!stateIncomeTaxForm.form.valid">
                    </button> -->
        </div>
        <div class="main-clear"></div>
    </p-footer>

</p-dialog>

<!-- Dialog for deductions -->
<p-dialog header="Federal Income Tax" [(visible)]="federalTaxDialog" *ngIf="federalTaxDialog" [responsive]="true" [modal]="true" [style]="DialogStyle40">
    <form #federalIncomeTaxForm="ngForm">
        <div class="p-grid">
            <div class="p-grid" *ngFor="let question of questionList" [ngSwitch]="question.parameterName">
                <ng-container *ngSwitchCase="w4Params.TotalAllowances">
                    <ng-container *ngIf="!show2020TaxFields">
                      <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>


                            <div class="p-col-12 p-md-8 p-lg-8">
                                <input type="text" pInputText placeholder="{{question.description}}" id="'total_allowances'" name="'total_allowances'"
                                       [(ngModel)]="federalFormData[question.parameterName]"
                                       [required]="!question.isOptional">
                            </div>
                      </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.TwoJobs">
                    <ng-container *ngIf="show2020TaxFields">
                      <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>


                        <div class="p-col-12 p-md-8 p-lg-8">
                            <p-dropdown [options]="question.options" placeholder="Select..." appendTo="body" class="form-control" name="'question.description'" [(ngModel)]="federalFormData[question.parameterName]"
                                            [required]="!question.isOptional"></p-dropdown>

                        </div>
                      </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.Deductions">
                    <ng-container *ngIf="show2020TaxFields">
                      <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>

                        <div class="p-col-12 p-md-8 p-lg-8">
                            <input type="text" pInputText placeholder="{{question.description}}" id="'deductions'" name="'deductions'"
                                   [(ngModel)]="federalFormData[question.parameterName]"
                                   [required]="!question.isOptional">
                        </div>
                      </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.OtherIncome">
                    <ng-container *ngIf="show2020TaxFields">
                      <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>

                        <div class="p-col-12 p-md-8 p-lg-8">
                            <input type="text" pInputText placeholder="{{question.description}}" id="'otherIncome'" name="'otherIncome'"
                                   [(ngModel)]="federalFormData[question.parameterName]"
                                   [required]="!question.isOptional">
                        </div>
                      </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.DependentsAmt">
                    <ng-container *ngIf="show2020TaxFields">
                      <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>


                            <div class="p-col-12 p-md-8 p-lg-8">
                                <input type="text" pInputText placeholder="{{question.description}}" id="'dependents_amt'" name="'dependents_amt'"
                                       [(ngModel)]="federalFormData[question.parameterName]"
                                       [required]="!question.isOptional">
                            </div>
                      </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.W42020">
                  <div class="p-grid">
                        <div class="p-col-12 p-md-4 p-lg-4">
                            <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                        </div>


                            <div class="p-col-12 p-md-8 p-lg-8">
                                <p-dropdown [options]="question.options" placeholder="Select..." appendTo="body" class="form-control"
                                            name="'2020_w4'" [(ngModel)]="federalFormData[question.parameterName]"
                                            [required]="!question.isOptional" (onChange)="handle2020W4(federalFormData[question.parameterName])"></p-dropdown>

                            </div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="w4Params.FilingStatus">
                  <div class="p-grid">
                    <div class="p-col-12 p-md-4 p-lg-4">
                        <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                    </div>


                    <div class="p-col-12 p-md-8 p-lg-8">
                        <p-dropdown [options]="filingStatusOptions" placeholder="Select..." appendTo="body" class="form-control"
                                    name="'Filing_Status'" [(ngModel)]="federalFormData[question.parameterName]"
                                    [required]="!question.isOptional"></p-dropdown>

                    </div>
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="p-grid">
                <div class="p-col-12 p-md-4 p-lg-4">
                    <label for="{{question.description}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                </div>

                <div [ngSwitch]="question.regexType">

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'SingleValue'">
                        <input type="text" pInputText placeholder="{{question.description}}" id="{{question.description}}" name="{{question.description}}" [(ngModel)]="federalFormData[question.parameterName]"
                               [required]="!question.isOptional">
                    </div>

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'PickList'">
                        <p-dropdown [options]="question.options" placeholder="Select..." appendTo="body" class="form-control" name="{{question.description}}" [(ngModel)]="federalFormData[question.parameterName]"
                                    [required]="!question.isOptional"></p-dropdown>

                    </div>
                </div>
                  </div>
                </ng-container>
            </div>
        </div>
        <!-- File Upload -->
        <div class="p-grid" *ngIf="uiName == 'profile' || uiName == 'payee'">
            <div class="p-col-12 p-md-4 p-lg-4">
                <label>File*&nbsp;
                </label>

            </div>
            <div class="p-col-12 p-md-8 p-lg-8">
        <span *ngIf="newFederalFileName">
          {{newFederalFileName}}
        </span>
                <span *ngIf="newFederalFileError">Federal and State file name cannot be same</span>
                <span style="cursor:pointer;padding-left:10px;">
          <app-file-load *ngIf="federalFormData&&federalTaxDialog" [docType]="DocumentType.W4Form" (loadHandler)="handleLoadedFederalFile($event)" [chooseLabel]="fileUploadLabel">
          </app-file-load>
        </span>
            </div>
        </div>
        <!-- End File Upload -->
    </form>
    <p-footer>
        <div class="p-col-12" style="text-align:right;">
            <button type="button" pButton class="button-inaction" icon="fa fa-close" (click)="federalTaxDialog = false" label="Cancel"></button>
            <button type="button" pButton class="button-action" icon="fa fa-check" label="Add"
                    (click)="addFederalTax()" [disabled]="!federalIncomeTaxForm.form.valid || ((newFederalFileError || !newFederalFileName) &&
                    (uiName == 'profile' || uiName == 'payee'))" >
            </button>
        </div>
        <div class="main-clear"></div>
    </p-footer>

</p-dialog>


<!-- Dialog for deductions -->
<p-dialog header="Local Income Tax" [(visible)]="localTaxDialog" *ngIf="localTaxDialog" [responsive]="true" [modal]="true" [style]="DialogStyle40">
    <form #localIncomeTaxForm="ngForm">
        <ul>
            <li class="p-gird" *ngFor="let question of localTaxForm">
                <div class="p-col-12 p-md-4 p-lg-4">
                    <label for="{{question.key}}">{{question.description}}<span *ngIf="!question.isOptional">*</span></label>
                </div>

                <div [ngSwitch]="question.regexType">

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'SingleValue'">
                        <input type="text" pInputText placeholder="{{question.description}}" name="{{question.description}}" [(ngModel)]="localFormData[question.parameterName]" [required]="!question.isOptional">
                    </div>

                    <div class="p-col-12 p-md-8 p-lg-8" *ngSwitchCase="'PickList'">
                        <p-dropdown [options]="question.options" placeholder="Select..." class="form-control" name="{{question.description}}" [(ngModel)]="localFormData[question.parameterName]"
                                    [required]="!question.isOptional"></p-dropdown>

                    </div>

                </div>
            </li>
        </ul>

    </form>
    <p-footer>
        <div class="p-col-12" style="text-align:right;">
            <button type="button" class="button-inaction" pButton icon="fa fa-close" (click)="localTaxDialog = false" label="Cancel"></button>
            <button type="button" class="button-action" pButton icon="fa fa-check" [disabled]="!localIncomeTaxForm.form.valid" (click)="addLocalTax()" label="Add">
            </button>
            <!-- <button type="button" pButton icon="fa fa-check" (click)="updateTax()" label="Update" *ngIf="!newTax" [disabled]="!localIncomeTaxForm.form.valid">
                    </button> -->
        </div>
        <div class="main-clear"></div>
    </p-footer>

</p-dialog>
